export default [
  {
    path: 'profit-loss/by-product-imei',
    name: 'report-product-imei-revenue',
    component: () =>
      import(
        '@/view/pages/reports/product-imei-revenue-report/ListProductImeiRevenueReport.vue'
      ),
    meta: {
      title: 'Báo cáo lãi lỗ theo sản phẩm IMEI - CLICKBUY',
    },
  },
]
